import { FieldArray, useFormikContext } from 'formik'

import { BUILDING_FORM_FIELD_NAME_INSURANCES } from '../BuildingForm.constants'

import { Fields } from './Fields'

function BuildingFormInsuranceFields() {
  const { values } = useFormikContext()

  return (
    <FieldArray
      name={BUILDING_FORM_FIELD_NAME_INSURANCES}
      validateOnChange={false}
    >
      {({ remove }) =>
        values[BUILDING_FORM_FIELD_NAME_INSURANCES].map((_, index) => (
          <Fields index={index} key={index} onRemove={remove} />
        ))
      }
    </FieldArray>
  )
}

export default BuildingFormInsuranceFields
